"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountSelectV2 = void 0;
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var styles = _interopRequireWildcard(require("./AccountSelect.css"));
var _Account = require("./components/Account");
var _preparePublishedAnnouncements = require("./utils/preparePublishedAnnouncements");
var _formatString = require("../../utils/formatString");
var _prepareLastActivityDate = require("./utils/prepareLastActivityDate");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const AccountSelectV2 = _ref => {
  let {
    phone,
    accounts,
    phoneАccounts,
    loadableAccount,
    continueByPhoneLoading,
    continueByAccountLoading,
    onAccountSelect,
    switchToRegistration
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['wrapper'], {
      [styles['wrapper-scroll']]: accounts.length >= 4
    })
  }, accounts.map(_ref2 => {
    let {
      name,
      email,
      agencyName,
      publishedAnnouncementsCount,
      avatarUrl,
      lastActivityDate,
      phone
    } = _ref2;
    return name && /*#__PURE__*/React.createElement(_Account.Account, {
      key: `account_${name}`,
      email: name,
      agencyName: agencyName,
      publishedAnnouncementsCount: (0, _preparePublishedAnnouncements.preparePublishedAnnouncements)(publishedAnnouncementsCount),
      lastActivityDate: (0, _prepareLastActivityDate.prepareLastActivityDate)(lastActivityDate),
      avatarUrl: avatarUrl,
      disabled: continueByAccountLoading || continueByPhoneLoading,
      loading: loadableAccount === name && continueByAccountLoading,
      onClick: () => onAccountSelect({
        email,
        phone
      })
    });
  }), phoneАccounts.length === 0 && /*#__PURE__*/React.createElement(_Account.Account, {
    onClick: switchToRegistration,
    disabled: continueByPhoneLoading || continueByAccountLoading,
    loading: continueByPhoneLoading,
    phone: `Создать новый аккаунт для номера ${(0, _formatString.formatPhoneWithSpecialChars)(phone)}`
  }));
};
exports.AccountSelectV2 = AccountSelectV2;